export default __webpack_public_path__ + "static/media/fox.798ec169.png";